import Video from '@uikit/components/Video/Video';
import videoThumbnail from '../../assets/images/easygo-video-thumbnail.jpg';
import { ContentContainer } from '../ContentContainer/ContentContainer';
import { Headline } from '../Headline/Headline';
import { Text } from '../Text/Text';
import styles from './VideoSection.module.scss';

export const VideoSection = () => {
  return (
    <section className={styles.base}>
      <ContentContainer>
        <Headline color="gradient" level={2}>
          enercity easyGo ist die smarte Lösung fürs Laden unterwegs
        </Headline>

        <Text align="center" weight={300} width="m" className={styles.subTitle}>
          Ob Vielfahrerin oder nur gelegentlich mit dem E-Auto unterwegs - bei
          uns finden Sie den passenden Ladetarif. Einfach App installieren,
          registrieren, Zahlungsmethode wählen - und los geht&apos;s.
        </Text>
        <Text align="center" weight={300} width="m" className={styles.subTitle}>
          Wie Sie blitzschnell eine freie Ladesäule finden und den Ladevorgang
          per App starten, zeigt unser Video.
        </Text>

        <div className={styles.videoContainer}>
          <Video
            muted={false}
            thumbnail={{
              name: 'Enercity easyGo: so funktioniert die App',
              path: videoThumbnail.src,
            }}
            videoName="enercity-easy-go-so-funktioniert-die-app"
          />
        </div>
      </ContentContainer>
    </section>
  );
};
